/* --------------------------------------
   RQ! added this file for custom JS
   -------------------------------------- */

/* RQ! JS for Quick Announcement Bar fix - STARTS */
$( document ).ready(function() { 
   setInterval(function(){ //used to be setTimeout
     var heightanu = $("div#qab_background").height();
     $(".header-section").css("padding-top", heightanu+"px");
     $('#qab_close').parent().addClass("padclose");
   }, 1000);  //used to be 3000
  
   $('body').on('click', 'div.padclose', function(){
    $("a#qab_close").trigger('click');
    $(".header-section").css("padding-top", "0px");
   });
  
   setTimeout(function(){ 
     var getfinal = $(".rq-getfinal-sale").html();
    // alert(getfinal);
     $(".rq-get-finalhtml span").after(getfinal);
   }, 1000);
  
}); 
	/* RQ! JS for Quick Announcement Bar fix - ENDS */


/* finale sale - STARTS */
$( document ).ready(function() { 
  
  
  
  var rqheight = $("h1.product_name.title").height();
  
 
  
  if(rqheight >= 35 )
  {
    $(".rq-finale-sale-div span.u-visually-hidden").css("top", "-6px");
  }
  
  
  
  $(".rq-finale-sale-div span.u-visually-hidden").hide();
  
  
  $('body').on('mouseover', '.rq-final-sale-span', function(){
    //alert('gg');
    //$(".rq-finale-sale-div  span.u-visually-hidden").show();
  });
  
  
  
  
   if (window.matchMedia('(max-width: 1024px)').matches) {  
      
     $('body').on('click', '.gb-cross-sign', function(){
       //alert('gg');
       $(".rq-finale-sale-div  span.u-visually-hidden").attr("style","display:none !important");
     });
     $('body').on('mouseover', '.rq-final-sale-span', function(){
      $(".rq-finale-sale-div  span.u-visually-hidden").attr("style","inline-table !important");
     });
     
   }else {
      //$('body').on('mouseleave', '.rq-final-sale-span', function(){
      //alert('gb');
     // $(".rq-finale-sale-div  span.u-visually-hidden").hide();
    // });
   }
  
  
  
  
  
   $('body').on('click', '.rq-finale-sale-div span.u-visually-hidden u', function(){
     
     
   if (window.matchMedia('(max-width: 768px)').matches) {  
     
     
     $('html,body').animate({
     scrollTop: $(".accordion").offset().top},
     'slow');
     $(".product__information .accordion dt:last-child").trigger('click');
     $(".product__information .accordion dd:last-child").attr("aria-hidden","false");
      
   }
   else {
     
      $('html,body').animate({
      scrollTop: $(".tablast").offset().top},
      'slow');
      $("li.tablast").trigger('click');
   }
     
     
     
   });
  
  
  
}); 
/* finale sale - STARTS */


// /* MENU - STARTS */
// $( document ).ready(function() { 
//     setTimeout(function(){ 
//       var getheight = $("div#FreeShippingBanner").height();
//        if(getheight >= 60) {
//          //alert('gg');
//         $(".rq-mob-menu-bottom").css("bottom", "140px");
//       }
//       if(getheight >= 90) {
//         $(".rq-mob-menu-bottom").css("bottom", "170px");
//       }
//     }, 5000);
// });   
// /* MENU - END */
 
// /* MENU - STARTS */
// $( document ).ready(function() { 
//     setTimeout(function(){ 
//       var getheight = $("div#FreeShippingBanner").height();
//        if(getheight >= 60) {
//          //alert('gg');
//         $(".rq-mob-menu-bottom").css("bottom", "140px");
//       }
//       if(getheight >= 90) {
//         $(".rq-mob-menu-bottom").css("bottom", "170px");
//       }
//     }, 5000);
// });   
/* MENU - END */
 
/* MOBILE MENU CLICK - STARTS */
$( document ).ready(function() { 
   $('body').on('click', '.rq-first-level-menu', function(){ 
     // $('.rq-first-level-menu').prop("checked", false);
     //$(this).prop("checked", true); 
     if($(this).is(":checked")){
       $('.rq-first-level-menu').prop("checked", false);
       $(this).prop("checked", true); 
     } 
     else {
      $(this).prop("checked", false);
    }
   });  
});          
/* MOBILE MENU CLICK - STARTS */


/* MOBILE MENU CLICK SEARCH - STARTS */
// $( document ).ready(function() {   
//    $('body').on('click', '.rq-new-click-serach-added', function(){
//     if (window.matchMedia('(max-width: 767px)').matches) {  
//       $('.bc-sf-search-suggestion-mobile-top-panel').show();
//       $('.bc-sf-search-suggestion-mobile-overlay').show();
//     }
//      if (window.matchMedia('(min-width: 768px)').matches) { 
//         $('.search-overlay').show();
//       } 
     
//    });  
//    $('body').on('click', '.button.bc-sf-search-btn-close-suggestion', function(){
//      $('.bc-sf-search-suggestion-mobile-top-panel').hide();
//      $('.bc-sf-search-suggestion-mobile-overlay').hide();
//    });
  
//    $('body').on('click', 'span.icon.search-overlay__close', function(){
     
//      if (window.matchMedia('(min-width: 768px)').matches && window.matchMedia('(max-width: 1023px)').matches) {  
//       $('.search-overlay').hide();
//       }
//    });
  
// });  
/* MOBILE MENU CLICK SEARCH - ENDS */


/*$( document ).ready(function() {  
 setTimeout(function(){
  $(".variant-selection__variants option:eq(1)").prop("selectedIndex", 0);
   
 }, 4000);
});  */

$( document ).ready(function(event) {  
  var getvariantfirst_cond = $(".variant-selection__variants option:eq(2)").val();  
  if(getvariantfirst_cond == undefined )  { 
    setInterval(function () {
       var getvariantfirst = $(".variant-selection__variants option:eq(1)").val();
       $(".variant-selection").attr('variant' , getvariantfirst)
     }, 100);
  }
  
 /*var timesRun = 0;
 var interval = setInterval(function(){
    timesRun += 1;
    if(timesRun === 2){
       var getvariantfirst = $(".variant-selection__variants option:eq(1)").val();
       $(".gbvariant-selection").attr('variant' , getvariantfirst)
        clearInterval(interval);
    }
    //do whatever here..
 } , 2000); */  
});  


// product image hover START
/*$( document ).ready(function() {  
  //$( ".has-secondary-image-swap .transition--appear" ).hover(
  $('body').on('hover', '.has-secondary-image-swap .transition--appear',  
  function() { 
    $( this ).addClass('swap--visible');
     $( this ).closest(".product__thumbnail.product__grid-item").find(".secondary").removeClass('swap--visible');
  }, function() {
  }
 );
 $( ".has-secondary-image-swap .thumbnail-overlay__container" ).hover(
  function() { 
  }, function() {
     $(".transition--appear").removeClass('swap--visible');
     $(".secondary").addClass('swap--visible');
  }
 );  
  
});  */
// product image hover END


/*RQ! added if statement for Global-e fixed priced integration - STARTS*/
$( document ).ready(function() {   
   $('body').on('click', '.quick-shop__buttons span.quick_shop', function(){
     var get_val_attr = $( this ).closest(".product-wrap").find("span.product-thumbnail__price.price span.money").attr('data-fp');
     setTimeout(function () {
       $("div#quickshop .modal_price.subtitle span.money").attr('data-fp' , get_val_attr);
     }, 2000);   
   });  
});      
/*RQ! added if statement for Global-e fixed priced integration - ENDS*/


// Category section slider
(function() {
  let categorySlider = $('.category-slider');

  const slideData = {
    collections_per_row: categorySlider.data('collections-per-row'),
    collections_amount: categorySlider.data('collections-amount'),
  }

  $(categorySlider).flickity({
    lazyLoad: 2,
    freeScroll: true,
    imagesLoaded: true,
    draggable: true,
    cellAlign: 'center',
    pageDots: false,
    contain: true,
    prevNextButtons: slideData.collections_amount > slideData.collections_per_row ? true : false,
    initialIndex: 1,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 70, y2: 40,
      x3: 30
    },
    on: {
      ready: function() {
        // Resize flickity when the slider is settled
        $(categorySlider).on( 'settle.flickity', function() {
          $(categorySlider).flickity('resize')
        });
      }
    }
  });

})();

// Mobile filters toggle button
(function() {
  $('.js-toggle-filters').click(function(){
    $('.faceted-filter-form--mobile').addClass('active');
  });
})();



(function() {
  $('.collection__faceted-filter .sidebar-block__heading').click(function(){
    if ($(this).hasClass('active')) {
      $(this).toggleClass('active');
      $(this).closest('.collection__faceted-filter').find('.faceted-filter-list').toggleClass('active');  
    } else {
      $('.collection__faceted-filter .sidebar-block__heading').removeClass('active');
      $('.faceted-filter-list').removeClass('active');
      $(this).toggleClass('active');
      $(this).closest('.collection__faceted-filter').find('.faceted-filter-list').toggleClass('active');
    }
  });
})();

(function() {
  $('#sort-by').click(function(){
    $('.collection__faceted-filter .sidebar-block__heading').removeClass('active');
    $('.faceted-filter-list').removeClass('active');
  });
})();

(function() {
  $('.faceted-filter-list__close').click(function(){
    $(this).closest('.faceted-filter-list').removeClass('active');
  });
})();

(function() {
  $('.faceted-filter-form__close').click(function(){
    $(this).closest('.faceted-filter-form--mobile').removeClass('active');
  });
})();
